/** @format */

import _ from 'lodash';
import { createTheme, responsiveFontSizes, type ThemeOptions } from '@mui/material/styles';
import { THEMES } from 'src/constants';
import { softShadows } from './shadows';
import typography from './typography';

type ThemeConfig = {
  theme?: string;
  direction?: 'ltr' | 'rtl';
  responsiveFontSizes?: boolean;
};

const baseOptions: ThemeOptions = {
  direction: 'ltr',
  typography,
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: 16,
          backgroundColor: 'transparent'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: 14
        }
      }
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 3,
          overflow: 'hidden'
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 32
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0,0,0,0.075)'
        }
      }
    }
  }
};

const themesOptions = [
  {
    name: THEMES.AUMOVIO_AFM,
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 0
          }
        }
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            fontSize: 21.34
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            '&::placeholder': {}
          }
        }
      },
      MuiCheckbox: {
        styleOverrides: {
          colorSecondary: {
            color: '#001f37',
            '&.Mui-checked': {
              color: '#33c0ef'
            }
          }
        }
      }
    },
    palette: {
      mode: 'light',
      background: {
        default: '#ffffff',
        dark: '#001f37'
      },
      primary: {
        main: '#33c0ef'
      },
      secondary: {
        main: '#003c6b'
      },
      text: {
        primary: '#001f37',
        secondary: '#003c6b'
      }
    },
    shadows: softShadows
  }
];

export const createContiTheme = (config: ThemeConfig = {}) => {
  let themeOptions = themesOptions.find(theme => theme.name === config.theme);

  if (!themeOptions) {
    console.warn(new Error(`The theme ${config.theme} is not valid`));
    [themeOptions] = themesOptions;
  }

  const { name: _ignoredName, ...muiThemeOptions } = themeOptions;
  let theme = createTheme(
    _.merge({}, baseOptions, muiThemeOptions, { direction: config.direction }) as ThemeOptions
  );

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
